// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/route_style.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/route_style.proto.
 */
export const file_travplaces_v1_route_style: GenFile = /*@__PURE__*/
  fileDesc("Ch90cmF2cGxhY2VzL3YxL3JvdXRlX3N0eWxlLnByb3RvEg10cmF2cGxhY2VzLnYxIqgCCgpSb3V0ZVN0eWxlEgoKAmlkGAEgASgJEgsKA2tleRgCIAEoCRIPCgdjaXR5X2lkGAMgASgJEg0KBWxhYmVsGAQgASgJEgwKBGljb24YBSABKAkSEwoLZGVzY3JpcHRpb24YBiABKAkSFQoNY2F0ZWdvcnlfa2V5cxgHIAMoCRIbChNib29zdF9jYXRlZ29yeV9rZXlzGAggAygJEhcKD3Byb21pbmVuY2VfYmlhcxgJIAEoCRIUCgxkZWZhdWx0X21vZGUYCiABKAkSGQoRc2FmZXR5X3ByZWZlcmVuY2UYCyABKAkSGAoQZHdlbGxfbXVsdGlwbGllchgMIAEoARIRCgltYXhfc3RvcHMYDSABKAUSEwoLdGltZV9vZl9kYXkYDiABKAkiKQoWTGlzdFJvdXRlU3R5bGVzUmVxdWVzdBIPCgdjaXR5X2lkGAEgASgJIkoKF0xpc3RSb3V0ZVN0eWxlc1Jlc3BvbnNlEi8KDHJvdXRlX3N0eWxlcxgBIAMoCzIZLnRyYXZwbGFjZXMudjEuUm91dGVTdHlsZTKCAQoRUm91dGVTdHlsZVNlcnZpY2USbQoPTGlzdFJvdXRlU3R5bGVzEiUudHJhdnBsYWNlcy52MS5MaXN0Um91dGVTdHlsZXNSZXF1ZXN0GiYudHJhdnBsYWNlcy52MS5MaXN0Um91dGVTdHlsZXNSZXNwb25zZSILiuowAwoBCpDqMAFCqgEKEWNvbS50cmF2cGxhY2VzLnYxQg9Sb3V0ZVN0eWxlUHJvdG9QAVovdHJhdnBsYWNlcy9nZW4vcHJvdG8vdHJhdnBsYWNlcy92MTt0cmF2cGxhY2VzdjGiAgNUWFiqAg1UcmF2cGxhY2VzLlYxygINVHJhdnBsYWNlc1xWMeICGVRyYXZwbGFjZXNcVjFcR1BCTWV0YWRhdGHqAg5UcmF2cGxhY2VzOjpWMWIGcHJvdG8z", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * RouteStyle is a planner preset: which categories to draw candidates from,
 * how fast to move, how long to linger, and whether to favour famous places
 * or overlooked ones. Styles are data (admin-editable), not an enum, and may
 * be global (city_id empty) or scoped to a single city.
 *
 * @generated from message travplaces.v1.RouteStyle
 */
export type RouteStyle = Message<"travplaces.v1.RouteStyle"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * empty = available in every city
   *
   * @generated from field: string city_id = 3;
   */
  cityId: string;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: string icon = 5;
   */
  icon: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * Candidate pool for this style, by category key.
   *
   * @generated from field: repeated string category_keys = 7;
   */
  categoryKeys: string[];

  /**
   * Categories worth extra weight when ranking candidates.
   *
   * @generated from field: repeated string boost_category_keys = 8;
   */
  boostCategoryKeys: string[];

  /**
   * popular | neutral | hidden
   *
   * @generated from field: string prominence_bias = 9;
   */
  prominenceBias: string;

  /**
   * @generated from field: string default_mode = 10;
   */
  defaultMode: string;

  /**
   * off | prefer
   *
   * @generated from field: string safety_preference = 11;
   */
  safetyPreference: string;

  /**
   * @generated from field: double dwell_multiplier = 12;
   */
  dwellMultiplier: number;

  /**
   * @generated from field: int32 max_stops = 13;
   */
  maxStops: number;

  /**
   * any | morning | afternoon | evening
   *
   * @generated from field: string time_of_day = 14;
   */
  timeOfDay: string;
};

/**
 * Describes the message travplaces.v1.RouteStyle.
 * Use `create(RouteStyleSchema)` to create a new message.
 */
export const RouteStyleSchema: GenMessage<RouteStyle> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_style, 0);

/**
 * @generated from message travplaces.v1.ListRouteStylesRequest
 */
export type ListRouteStylesRequest = Message<"travplaces.v1.ListRouteStylesRequest"> & {
  /**
   * optional; empty = global styles only
   *
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.ListRouteStylesRequest.
 * Use `create(ListRouteStylesRequestSchema)` to create a new message.
 */
export const ListRouteStylesRequestSchema: GenMessage<ListRouteStylesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_style, 1);

/**
 * @generated from message travplaces.v1.ListRouteStylesResponse
 */
export type ListRouteStylesResponse = Message<"travplaces.v1.ListRouteStylesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.RouteStyle route_styles = 1;
   */
  routeStyles: RouteStyle[];
};

/**
 * Describes the message travplaces.v1.ListRouteStylesResponse.
 * Use `create(ListRouteStylesResponseSchema)` to create a new message.
 */
export const ListRouteStylesResponseSchema: GenMessage<ListRouteStylesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_style, 2);

/**
 * RouteStyleService exposes the (seeded, admin-editable) route-style presets.
 *
 * @generated from service travplaces.v1.RouteStyleService
 */
export const RouteStyleService: GenService<{
  /**
   * ListRouteStyles returns the active styles offered for a city (global set
   * plus any city overrides), or the global set when city_id is empty.
   *
   * @generated from rpc travplaces.v1.RouteStyleService.ListRouteStyles
   */
  listRouteStyles: {
    methodKind: "unary";
    input: typeof ListRouteStylesRequestSchema;
    output: typeof ListRouteStylesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_route_style, 0);

